var XPortal = XPortal || {};
XPortal.DefaultEditor =
{
    ControlSelector: ".xpand-default",
    ControlSelectorNotInFSet: ".xpand-default:not(.dynamic-filter-set .xpand-default)",
    Init: function (container, exceptFSets) {
        var self = this;
        container = container ? container : $(XPortal.Main.DetialFormSelector);
        container.find(exceptFSets ? self.ControlSelectorNotInFSet : self.ControlSelector).each(function () {
            self.initFor(XPortal.Store.getModelName(container[0].id), $(this));
        });
    },
    SetModification: function (el, elval) {
        elval = elval || el.val();
        if (el) el.attr("data-store-val", elval);
    },
    ClearModification: function (el, elval) {
        if (el) el.removeAttr("data-store-val");
    },
    IsModified: function (el, elval) {
        if (!el || el.length < 1) return false;
        if (!el.is('[data-store-val]')) return false;
        if (el.attr("data-store-val").length == 0) return false;
        elval = elval || el.val();
        if (el.attr("data-store-val") === elval) return false;
        return true;
    },

    initFor: function (modelName, el, isInlineEditor = false) {
        const sttgs = XPortal.Main.GetSettingsFor(el);
        el.change(function () {
            XPortal.DefaultEditor.SetModification(el);
            if (!isInlineEditor) {
                el.trigger("dispatchFieldEvent");
            }
        });

        if (isInlineEditor && el) $(el).attr("data-skip", "");

        el.bind("dispatchFieldEvent", function (e) {
            XPortal.Store.FieldEvent(el[0], el.val(), modelName, sttgs);
        });

        XPortal.Store.Subscribe({ Model: modelName, Field: sttgs.fieldname, Target: el },
            (value) => !XPortal.DefaultEditor.IsModified(el) ? el.val(value) : false,
            (value) => el ? el.val() : false
        );
    }
};